import React from 'react';
import { isString, stripHtml, normalizeTimeValue } from '../helpers';
import { getEnrichedValue } from '../labelGetters';
import TextDiff from './TextDiff';

export default function PrimitiveDiff({
  beforeValue,
  afterValue,
  fieldName,
  labels,
}) {
  const beforeRaw = beforeValue ?? '';
  const afterRaw = afterValue ?? '';
  let before = isString(beforeRaw) ? stripHtml(beforeRaw) : beforeRaw;
  let after = isString(afterRaw) ? stripHtml(afterRaw) : afterRaw;

  // Normalize time values for arrival/departure time fields
  if (
    fieldName === 'arrivalTime' ||
    fieldName === 'departureTime' ||
    fieldName?.endsWith('Time')
  ) {
    before = normalizeTimeValue(before);
    after = normalizeTimeValue(after);
  }

  // Try to get enriched display values from labels
  const enrichedBefore = getEnrichedValue(beforeValue, fieldName, labels, true);
  const enrichedAfter = getEnrichedValue(afterValue, fieldName, labels, false);
  const displayBefore = enrichedBefore || String(before);
  const displayAfter = enrichedAfter || String(after);

  return <TextDiff beforeValue={displayBefore} afterValue={displayAfter} />;
}
